import request from 'services/axios';

export const editWantedPost = async (payload: EditwantedBody) => {
  const {data} = await request.put(`/api/v2/market/wanted-post`, {
    ...payload,
  });
  return data;
};
